import { successStatusCodes, httpErrorMessage } from './config';

function createHTTP({ axios, $bus, $alert, $toast }, handlers) {
  const {
    requestHandler,
    requestErrorHandler,
    responseHandler,
    responseErrorHandler
  } = handlers;

  function defaultErrorHandler(message) {
    $bus.emit('on-error', message || httpErrorMessage.default);
  }

  axios.interceptors.request.use(
    (config) => {
      if (config.loading) {
        $bus.emit('on-request');
      }

      requestHandler && requestHandler(config);

      return config;
    },
    (error) => {
      requestErrorHandler && requestErrorHandler(error);

      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      const { data, status, statusText, config } = response;

      config?.loading && $bus.emit('on-response');

      if (successStatusCodes.includes(status)) {
        if (!responseHandler) {
          console.error('`responseHandler` is required');
        }

        return responseHandler
          ? responseHandler(data, {
              $bus,
              $alert,
              $toast,
              defaultErrorHandler
            })
          : Promise.resolve(data);
      } else {
        defaultErrorHandler(statusText);

        return Promise.reject(data);
      }
    },
    (error) => {
      responseErrorHandler && responseErrorHandler(error);

      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        $bus.emit('on-error', httpErrorMessage.response);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        $bus.emit('on-error', httpErrorMessage.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        $bus.emit('on-error', httpErrorMessage.unknown);
      }

      $bus.emit('on-response');

      return Promise.reject(error);
    }
  );
}

export default createHTTP;
